const actionMoveInDirectionSchema = [
  {
    type: 'number',
    name: 'duration',
    label: 'Duration (seconds):',
    min: '0',
    step: 0.2,
    vfeNumber: true,
    events: ['input'],
  },
  {
    type: 'select',
    label: 'Direction:',
    name: 'direction',
    options: {
      forward: 'Forward',
      backward: 'Backward',
      left: 'Left',
      right: 'Right',
      up: 'Up',
      down: 'Down'
    },
    events: ['input'],
    validation: 'required',
  },
  {
    type: 'number',
    name: 'distance',
    label: 'Distance:',
    min: '0',
    step: 0.5,
    vfeNumber: true,
    events: ['input'],
    validation: 'required',
  },
  {
    type: 'select',
    label: 'Easing:',
    name: 'easing',
    options: {
      linear: 'Linear',
      sinein: 'Smooth Start',
      sineout: 'Smooth End',
      sineinout: 'Smooth Start & End',
      elasticin: 'Elastic Start',
      elasticout: 'Elastic End',
      elasticinout: 'Elastic Start & End',
      backin: 'Overshoot on Start',
      backout: 'Overshoot on End',
      backinout: 'Overshoot on Start & End',
    },
    events: ['input'],
  }
]

const actionMoveInDirectionValue = {
  type: 'action_move_in_direction',
  duration: 1.0,
  direction: 'forward',
  distance: 1.0,
  easing: 'sineinout'
}

export { actionMoveInDirectionSchema, actionMoveInDirectionValue }